package com.yendo.mx.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import kotlin.js.Promise

@Composable
actual fun rememberGoogleAuthLauncher(
    onResult: (idToken: String?, nombre: String?, email: String?, fotoUrl: String?) -> Unit
): () -> Unit {
    val scope = rememberCoroutineScope()
    return {
        println("YENDO_WEB 🚀 [GoogleAuthLauncher] Clic en botón de Google recibido.")
        
        scope.launch {
            try {
                val googleAuthPromise = js("""
                    (function() {
                        var authModule = window.firebaseAuth || (typeof firebase !== 'undefined' ? firebase.auth : null);
                        if (!authModule && typeof require !== 'undefined') {
                            try { authModule = require('firebase/auth'); } catch(e) {}
                        }
                        if (!authModule) {
                            return Promise.reject(new Error("Firebase Auth JS SDK no encontrado en el entorno Web."));
                        }
                        var auth = authModule.getAuth ? authModule.getAuth() : (authModule.getInstance ? authModule.getInstance() : authModule());
                        var provider = authModule.GoogleAuthProvider ? new authModule.GoogleAuthProvider() : new firebase.auth.GoogleAuthProvider();
                        return authModule.signInWithPopup ? authModule.signInWithPopup(auth, provider) : auth.signInWithPopup(provider);
                    })()
                """).unsafeCast<Promise<dynamic>>()

                val result = googleAuthPromise.await()
                val user = result.user
                val idTokenPromise = (if (user.getIdToken != null) user.getIdToken() else user.getIdTokenResult()).unsafeCast<Promise<String>>()
                val idToken = idTokenPromise.await()

                val nombre = user.displayName.unsafeCast<String?>()
                val email = user.email.unsafeCast<String?>()
                val fotoUrl = user.photoURL.unsafeCast<String?>()

                println("YENDO_WEB ✅ Google Login Exitoso: $email ($nombre)")
                onResult(idToken, nombre, email, fotoUrl)
            } catch (e: Throwable) {
                val errorMsg = e.message ?: e.toString()
                println("YENDO_WEB ❌ Error en Google Auth -> $errorMsg")
                window.alert("Google Auth Error: $errorMsg")
                onResult(null, null, null, null)
            }
        }
    }
}
